// extracted by mini-css-extract-plugin
module.exports = {"root":"_6qkkq","replyReviewAvatar":"_35Z-x","replyReviewDetails":"_20il8","replyReviewDate":"_1ugKl","replyReviewBody":"_2SURX"};